import routes from 'app/min/routes';

export default {
  routes,
};
